import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getEnv = createSelector(
  ({ env }: RootState) => env,
  (env) => env,
);
